import React, { useState, useEffect } from "react";
import "./ProfitCalculator.css";

const ProfitCalculator = ({ totalCost }) => {
  const [paperbackPrice, setPaperbackPrice] = useState(0);
  const [paperbackQty, setPaperbackQty] = useState(0);
  const [ebookPrice, setEbookPrice] = useState(0);
  const [ebookQty, setEbookQty] = useState(0);

  const [paperbackSupplyPrice, setPaperbackSupplyPrice] = useState(0);
  const [paperbackProfitPerCopy, setPaperbackProfitPerCopy] = useState(0);

  const [ebookSupplyPrice, setEbookSupplyPrice] = useState(0);
  const [ebookProfitPerCopy, setEbookProfitPerCopy] = useState(0);

  const formatCurrency = (num) => {
    if (isNaN(num)) return "0";
    return num.toLocaleString("ko-KR");
  };

  useEffect(() => {
    const price = parseInt(paperbackPrice) || 0;
    const supplyPrice = Math.round(price * 0.65);
    const profit = Math.round(price * 0.55);
    setPaperbackSupplyPrice(supplyPrice);
    setPaperbackProfitPerCopy(profit);
    setEbookPrice(Math.round(price * 0.8));
  }, [paperbackPrice]);

  useEffect(() => {
    const price = parseInt(ebookPrice) || 0;
    const supplyPrice = Math.round(price * 0.5);
    const profit = Math.round(price * 0.4);
    setEbookSupplyPrice(supplyPrice);
    setEbookProfitPerCopy(profit);
  }, [ebookPrice]);

  const totalPaperbackProfit =
    (parseInt(paperbackQty) || 0) * paperbackProfitPerCopy;
  const totalEbookProfit = (parseInt(ebookQty) || 0) * ebookProfitPerCopy;
  const totalRevenue = totalPaperbackProfit + totalEbookProfit;
  const netProfit = totalRevenue - totalCost;

  const subTotalCost = Math.round(totalCost / 1.1);
  const taxCost = totalCost - subTotalCost;

  return (
    <div className="profit-calculator-section">
      <div className="profit-calculator-section-header">
        <div className="profit-calculator-title">
          <h2>손익분기점 예상</h2>
          <label>(자비 출판)</label>
        </div>

        <p style={{ whiteSpace: "pre-wrap" }}>
          {
            "<참고 사항> 전자책의 수익은 각 온라인 플랫폼의 판매·정산 방식에 따라 달라집니다."
          }
        </p>
      </div>

      <div className="calculator-grid">
        <div className="calc-inputs-area">
          <div className="book-type-section">
            <div className="book-type-title">종이책</div>
            <div className="book-type-calc-row">
              <div className="input-column">
                <div className="input-row">
                  <label>정가</label>
                  <input
                    type="number"
                    value={paperbackPrice}
                    onChange={(e) => setPaperbackPrice(e.target.value)}
                  />
                  <span>원</span>
                </div>
                <div className="input-row">
                  <label>판매량</label>
                  <input
                    type="number"
                    value={paperbackQty}
                    onChange={(e) => setPaperbackQty(e.target.value)}
                  />
                  <span>부</span>
                </div>
              </div>
              <div className="derived-column">
                <div className="derived-row">
                  <label>
                    공급가 <small>( 예시: 정가의 약 65% )</small>
                  </label>
                  <span>
                    <strong>{formatCurrency(paperbackSupplyPrice)}</strong> 원
                  </span>
                </div>
                <div className="derived-row">
                  <label>
                    수익 (1권) <small>( 예시: 정가의 약 50% )</small>
                  </label>
                  <span>
                    <strong>{formatCurrency(paperbackProfitPerCopy)}</strong> 원
                  </span>
                </div>
              </div>
            </div>
          </div>

          <hr className="calc-divider" />

          <div className="book-type-section">
            <div className="book-type-title">전자책</div>
            <div className="book-type-calc-row">
              <div className="input-column">
                <div className="input-row">
                  <label>정가</label>
                  <input
                    type="number"
                    value={ebookPrice}
                    onChange={(e) => setEbookPrice(e.target.value)}
                  />
                  <span>원</span>
                </div>
                <div className="input-row">
                  <label>판매량</label>
                  <input
                    type="number"
                    value={ebookQty}
                    onChange={(e) => setEbookQty(e.target.value)}
                  />
                  <span>부</span>
                </div>
              </div>
              <div className="derived-column">
                <div className="derived-row">
                  <label>
                    공급가 <small>( 예시: 전자책 정가의 약 50% )</small>
                  </label>
                  <span>
                    <strong>{formatCurrency(ebookSupplyPrice)}</strong> 원
                  </span>
                </div>
                <div className="derived-row">
                  <label>
                    수익 (1권) <small>( 예시: 전자책 정가의 약 40% )</small>
                  </label>
                  <span>
                    <strong>{formatCurrency(ebookProfitPerCopy)}</strong> 원
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="calc-summary-area">
          {/* <div className="summary-row">
            <label>소계</label>
            <span>{formatCurrency(subTotalCost)} 원</span>
          </div>
          <div className="summary-row">
            <label>부가세(10%)</label>
            <span>{formatCurrency(taxCost)} 원</span>
          </div> */}
          <div className="summary-row total-cost">
            <label>총비용</label>
            <span>{formatCurrency(totalCost)} 원</span>
          </div>
          <hr />
          <div className="summary-row total-profit">
            <label>총수입</label>
            {/* <span className={netProfit < 0 ? "loss" : "profit"}>
              {formatCurrency(netProfit)} 원
            </span> */}
            <span className="profit">{formatCurrency(totalRevenue)} 원</span>
          </div>
          <div className="summary-row">
            <label>종이책</label>
            <span>{formatCurrency(totalPaperbackProfit)} 원</span>
          </div>
          <div className="summary-row">
            <label>전자책</label>
            <span>{formatCurrency(totalEbookProfit)} 원</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfitCalculator;
